import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function Privacidad() {
  return <LegalLayout title="Política de Privacidad" data-id="element-317">
      <div className="space-y-6 text-muted-foreground font-light leading-relaxed" data-id="element-318">
        <p data-id="element-319">Última actualización: Mayo 2026</p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-320">
          1. Información que recopilamos
        </h2>
        <p data-id="element-321">
          En Glow Up Femenino, valoramos profundamente tu privacidad. Solo
          recopilamos los datos personales básicos y estrictamente necesarios
          (como tu nombre y correo electrónico) para procesar tus compras,
          entregar los productos digitales que has adquirido y brindarte soporte
          técnico si lo necesitas.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-322">
          2. Uso de tu información
        </h2>
        <p data-id="element-323">
          La información que nos proporcionas se utiliza exclusivamente para:
        </p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-324">
          <li data-id="element-325">Enviarte los enlaces de acceso a tus productos digitales.</li>
          <li data-id="element-326">Comunicarnos contigo respecto a tu compra.</li>
          <li data-id="element-327">Responder a tus consultas de soporte.</li>
        </ul>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-328">
          3. Protección de datos
        </h2>
        <p data-id="element-329">
          Tu información jamás será vendida, alquilada ni compartida con
          terceros para fines comerciales. Protegemos tus datos de manera
          responsable utilizando plataformas de pago seguras y encriptadas.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-330">
          4. Contacto
        </h2>
        <p data-id="element-331">
          Si tienes alguna pregunta o inquietud sobre cómo manejamos tu
          privacidad, por favor no dudes en escribirnos a{' '}
          <strong data-id="element-332">hola@paolarojas.com</strong>. Estamos aquí para ayudarte y
          asegurarnos de que te sientas segura en nuestro espacio.
        </p>
      </div>
    </LegalLayout>;
}